import PropTypes from 'prop-types'
import { driverKeyTypePropType } from './driver-key-type-prop-type'

/**
 * @typedef {Object} DriverKey
 * The driver key (card/device) for identifying a driver assigned to a vehicle.
 *
 * @property {string}       driverKeyId     - The key ID.
 * @property {string}       keyType         - The key type (currently 'IBUTTON' or 'GENERIC').
 * @property {string}       value           - The key value.
 * @property {string|null} [driverId]       - The driver.
 */
export const driverKeyPropType = PropTypes.shape({
    driverId: PropTypes.string,
    driverKeyId: PropTypes.string,
    keyType: driverKeyTypePropType.isRequired,
    value: PropTypes.string.isRequired
})
